// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"OrderBook_mainContainer_16KT8","pairRow":"OrderBook_pairRow_lehxE","text":"OrderBook_text_3AfVh"};